import { Component, EventEmitter, Input, Output, Signal } from '@angular/core';
import { CosmeticOptions } from '../../models/filter-models';
import { Color, Comparator, LabelSize, MinimapIconShape, MinimapIconSize } from "../../models/enums";
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { CosmeticControls } from '../cosmetic-controls.model';
import { SelectMinimapIconComponent } from '../../common/select/select-minimap-icon/select-minimap-icon.component';
import { tierStyleMap } from '../../common/helper';
import { SelectComponent, SelectOptionComponent } from '../../common/select/select.component';
import { CosmeticsService } from '../../services/cosmetics.service';
import { BaseComponent } from '../../common/base.component';

@Component({
  selector: 'app-cosmetic-settings',
  imports: [FormsModule, ColorPickerModule, SelectMinimapIconComponent, SelectComponent, SelectOptionComponent],
  templateUrl: './cosmetic-settings.component.html',
  styleUrl: './cosmetic-settings.component.scss'
})
export class CosmeticSettingsComponent extends BaseComponent {
  @Input({ required: true }) cosmeticOptions!: CosmeticOptions;
  @Input({ required: true }) cosmeticControls!: CosmeticControls;
  @Input({ required: true }) active!: boolean;
  @Input() filterClasses!: string;

  @Output('updateFilter') updateFilterEmitter = new EventEmitter<void>();

  Comparator = Comparator;
  MinimapIconShape = MinimapIconShape;
  MinimapIconSize = MinimapIconSize;
  Color = Color;
  LabelSize = LabelSize;

  presetColors!: Signal<string[]>;

  tierStyleMap = tierStyleMap;

  constructor(private cosmeticsService: CosmeticsService) {
    super();
    this.presetColors = this.cosmeticsService.presetColors;
  }

  colorPicked(event: string) {
    this.cosmeticsService.addRecentlyUsedColor(event);
    this.updateFilter();
  }

  toggleHighlight() {
    this.cosmeticOptions.highlight = !this.cosmeticOptions.highlight;
    if (this.cosmeticOptions.highlight) {
      if (!this.cosmeticOptions.highlightColor) this.cosmeticOptions.highlightColor = Color.White;
      if (!this.cosmeticOptions.minimapIconSize) this.cosmeticOptions.minimapIconSize = MinimapIconSize.Large;
      if (!this.cosmeticOptions.minimapIconShape) this.cosmeticOptions.minimapIconShape = MinimapIconShape.Circle;
      if (!this.cosmeticOptions.beam) this.cosmeticOptions.beam = true;
    }
    this.updateFilter();
  }

  toggleSound() {
    this.cosmeticOptions.alertSound = !this.cosmeticOptions.alertSound;
    if (this.cosmeticOptions.alertSound) {
      if (!this.cosmeticOptions.alertSoundSound) this.cosmeticOptions.alertSoundSound = '2';
      if (!this.cosmeticOptions.alertSoundVolume) this.cosmeticOptions.alertSoundVolume = 100;
    }
    this.updateFilter();
  }

  toggleBackgroundColor() {
    if (this.cosmeticOptions.backgroundColor) this.cosmeticOptions.backgroundColor = undefined;
    else this.cosmeticOptions.backgroundColor = 'rgba(0,0,0,0.9411)';
    this.updateFilter();
  }

  toggleBorderColor() {
    if (this.cosmeticOptions.borderColor) this.cosmeticOptions.borderColor = undefined;
    else this.cosmeticOptions.borderColor = 'rgba(200,200,200,1)';
    this.updateFilter();
  }

  toggleTextColor() {
    if (this.cosmeticOptions.textColor) this.cosmeticOptions.textColor = undefined;
    else this.cosmeticOptions.textColor = 'rgba(200,200,200,1)';
    this.updateFilter();
  }

  toggleFontSize() {
    if (this.cosmeticOptions.fontSize) this.cosmeticOptions.fontSize = undefined;
    else this.cosmeticOptions.fontSize = LabelSize.Normal;
    this.updateFilter();
  }

  nameChangeKeyDown(event: KeyboardEvent){
    const allowedChars = /^[a-zA-Z0-9 .\-_\\/]$/;
    const char = event.key;

    // Allow navigation keys (arrows, backspace, delete, etc.)
    if (event.ctrlKey || event.altKey || event.metaKey ||
      char.length > 1 || char === 'Backspace' || char === 'Delete' ||
      char === 'ArrowLeft' || char === 'ArrowRight' ||
      char === 'Tab' || char === 'Home' || char === 'End') {
      return;
    }

    // Prevent input of disallowed characters
    if (!allowedChars.test(char)) {
      event.preventDefault();
    }
  }

  playSound(sound: string | undefined) {
    if (!sound) return;
    const audio = new Audio();
    audio.src = `/sounds/sound${sound}.mp3`;
    audio.load();
    audio.play();
  }

  updateFilter() {
    this.updateFilterEmitter.emit();
  }
}
